export default __webpack_public_path__ + "static/hasan-c39193dca827cebf8c6aeddb2de6ad7e.jpg";